import React, { useState } from "react";
import classNames from "classnames";

import "./InfoModal.scss";
import { getString } from "./strings";
import { Language } from "../core";

interface InfoModalProps {
  language: Language;
  isOpen: boolean;
  onClose: () => void;
}
export const InfoModal: React.FC<InfoModalProps> = React.memo(
  ({ language, isOpen, onClose }) => {
    let [showingPrivacyPolicy, setShowingPrivacyPolicy] = useState(false);

    return (
      <div className={classNames("infoModal", { isOpen })}>
        <div className="infoModal--inner">
          {!showingPrivacyPolicy && (
            <>
              <p
                dangerouslySetInnerHTML={{
                  __html: getString(language, "introDescription")
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: getString(language, "appDescription")
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: getString(language, "eventDescription")
                }}
              />
            </>
          )}
          {showingPrivacyPolicy && (
            <>
              <p
                dangerouslySetInnerHTML={{
                  __html: getString(language, "privacyPolicy")
                }}
              />
            </>
          )}
          {!showingPrivacyPolicy && (
            <button onClick={() => setShowingPrivacyPolicy(true)}>
              {getString(language, "privacyPolicyButton")}
            </button>
          )}
          {showingPrivacyPolicy && (
            <button onClick={() => setShowingPrivacyPolicy(false)}>
              {getString(language, "backToInfoButton")}
            </button>
          )}
          <button onClick={onClose}>
            {getString(language, "closeInfoModal")}
          </button>
        </div>
      </div>
    );
  }
);
